import { Timeline } from '@tmov/design-system';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { getDataHorasFomatada } from '../../../../../../../../helpers/data-fns';
import {
  formatarCnpjCpfIMask,
  formatarPlaca,
  toTitleCase,
} from '../../../../../../../../helpers/formatador';
import {
  GridDadosItem,
  GridDadosItemText,
  GridTitle,
  TabContentContainer,
} from '../../../../../DadosGerais/styles';

function TabAcompanhamento({ dadosMotorista, eventos }) {
  const handleValidaCheckIn = evento =>
    evento.status === 'Na fila' && evento.nomeAutor === 'CHECK-IN';

  const getDescription = evento => {
    if (evento.dataAlteracao !== null) {
      const dataHorasFormatada = getDataHorasFomatada(evento.dataAlteracao);
      const checkIn = handleValidaCheckIn(evento) ? '(GPS)' : '';
      return `${dataHorasFormatada} ${checkIn}`;
    }

    if (evento.status !== 'Aguardando aprovação') {
      return '';
    }

    return 'Sem registro de log';
  };

  return (
    <TabContentContainer>
      <GridTitle>
        <GridDadosItemText>Dados do Motorista</GridDadosItemText>
      </GridTitle>

      <GridDadosItem>
        <GridDadosItemText regular>Motorista</GridDadosItemText>
        <GridDadosItemText>
          {dadosMotorista?.Nome && toTitleCase(dadosMotorista?.Nome)}
        </GridDadosItemText>
      </GridDadosItem>

      <Row>
        <GridDadosItem>
          <GridDadosItemText regular>CPF</GridDadosItemText>
          <GridDadosItemText>
            {formatarCnpjCpfIMask(dadosMotorista?.Cpf)}
          </GridDadosItemText>
        </GridDadosItem>
        <Col style={{ marginLeft: '10%' }}>
          <GridDadosItem>
            <GridDadosItemText regular>Placa</GridDadosItemText>
            <GridDadosItemText>
              {formatarPlaca(dadosMotorista?.PlacaCavalo)}
            </GridDadosItemText>
          </GridDadosItem>
        </Col>
      </Row>

      <GridDadosItem>
        <GridDadosItemText regular>Transportadora</GridDadosItemText>
        <GridDadosItemText>
          {dadosMotorista?.NomeTransportadora &&
            toTitleCase(dadosMotorista?.NomeTransportadora)}
        </GridDadosItemText>
      </GridDadosItem>

      <GridTitle>
        <GridDadosItemText>Tracking</GridDadosItemText>
        <Timeline>
          {eventos?.map(item => (
            <Timeline.CheckPoint
              key={item.status}
              title={item.status}
              subTitle={getDescription(item)}
              isActive={item.dataAlteracao !== null}
              noBar={item.status === 'Entregue'}
            />
          ))}
        </Timeline>
      </GridTitle>
    </TabContentContainer>
  );
}

const detailsType = PropTypes.shape({
  status: PropTypes.string,
  nomeAutor: PropTypes.string,
  dataAlteracao: PropTypes.string,
});

TabAcompanhamento.propTypes = {
  dadosMotorista: PropTypes.shape({
    IdLoteConjunto: PropTypes.number,
    IdLote: PropTypes.number,
    Nome: PropTypes.string,
    PlacaCavalo: PropTypes.string,
    Peso: PropTypes.string,
    EntradaFila: PropTypes.string,
    StatusInt: PropTypes.number,
    DataEmissaoCte: PropTypes.string,
    IsTransportadoraExterna: PropTypes.bool,
    NomeTransportadora: PropTypes.string,
    Status: PropTypes.string,
    Protocolo: PropTypes.string,
    IdFilial: PropTypes.number,
    LatitudeCheckin: PropTypes.number,
    LongitudeCheckin: PropTypes.number,
    UltimoCheckin: PropTypes.string,
    Cpf: PropTypes.string,
  }),
  eventos: PropTypes.arrayOf(detailsType),
};

TabAcompanhamento.defaultProps = {
  dadosMotorista: {},
  eventos: [],
};

export default TabAcompanhamento;
